import { render, staticRenderFns } from "./kontakt.vue?vue&type=template&id=5500576d&scoped=true&"
import script from "./kontakt.vue?vue&type=script&lang=js&"
export * from "./kontakt.vue?vue&type=script&lang=js&"
import style0 from "./kontakt.vue?vue&type=style&index=0&id=5500576d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5500576d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputsBackendErrors: require('/var/www/jaty-frontend/components/inputs/BackendErrors.vue').default,InputsInput: require('/var/www/jaty-frontend/components/inputs/Input.vue').default,InputsTextarea: require('/var/www/jaty-frontend/components/inputs/Textarea.vue').default,AuthFormSecondaryLink: require('/var/www/jaty-frontend/components/AuthFormSecondaryLink.vue').default})
